import { createSlice } from '@reduxjs/toolkit';

const popup2Slice = createSlice({
  name: 'popup2',
  initialState: {
    isPopup2Open: false, 
  },
  reducers: {
    openPopup2: (state) => {
      state.isPopup2Open = true;
    },
    closePopup2: (state) => {
      state.isPopup2Open = false;
    },
  },
});

// Export actions
export const { openPopup2, closePopup2 } = popup2Slice.actions;

// Export the reducer to configure store
export default popup2Slice.reducer;